export const redirectURI = 'https://mallmap.okii.com';
